
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13153',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13153",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.651",
  "client-types": "static-1.494",
  "data-fetching-client": "static-1.9918",
  "foundations-components": "static-1.8419",
  "foundations-components-legacy": "static-1.1444",
  "foundations-theming": "static-1.4728",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8289",
  "hub-http-shared-msw-handlers": "static-1.10550",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11744",
  "I18n": "static-7.1665",
  "jasmine-runner": "static-1.6713",
  "marketplace-discovery-studio-lib": "static-1.573",
  "marketplace-storefront-base": "static-1.13216",
  "quartz": "static-1.7396",
  "react-dlb": "static-1.87",
  "react-rhumb": "static-1.16972",
  "reactive-variable-buffer-atom": "static-1.3116",
  "reporting-testing-lib": "static-1.10585",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12781",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7579",
  "ui-addon-i18n": "static-1.11404",
  "ui-addon-react-router-dom": "static-1.9797",
  "unified-auth": "static-1.834",
  "unified-auth-core-lib": "static-1.1116",
  "usage-tracker": "static-1.7617",
  "usage-tracker-core": "static-1.7467",
  "customer-data-property-utils": "static-1.8359",
  "hub-http": "static-1.6473",
  "integrations-lib": "static-1.16957",
  "marketplace-ui-common": "static-1.20632",
  "marketplace-ui-install": "static-1.618",
  "property-management-iframe": "static-1.14038",
  "quartz-config": "static-1.1174",
  "quartz-core": "static-1.6615",
  "quartz-routing": "static-1.826",
  "quick-fetch": "static-1.4104",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4923",
  "ts-schema": "static-1.4267",
  "ui-universal-auth": "static-1.9320",
  "UIComponents": "static-3.8690",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3673",
  "quartz-webpack": "static-1.3620",
  "bend-plugin-quartz-routing": "static-1.474",
  "ai-components-ui-library": "static-1.9628",
  "codemirror": "static-5.99",
  "foundations-assets": "static-1.5144",
  "pulse": "static-1.885",
  "react-codemirror": "static-1.10899",
  "ui-extensions-preview-lib": "static-1.519",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4688",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2444",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9687",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.64",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5528",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.497",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2519",
  "ui-fonts": "static-1.1006",
  "ui-images": "static-2.1233",
  "bend-plugin-foundations-theming": "static-1.3211",
  "foundations-theming-base": "static-1.3713",
  "stylex": "static-1.38",
  "HeadJS": "static-2.791",
  "hs-test-utils-bend-plugin": "static-1.3400",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4577",
  "ui-addon-video-player": "static-1.8964",
  "ai-rendering-library": "static-1.11029",
  "chirp-fetch": "static-1.2154",
  "connections-embed-lib": "static-1.1454",
  "copilot-toolkit": "static-1.11774",
  "feedback-loader": "static-1.29754",
  "laboratory-lib": "static-3.7413",
  "marketplace-embed": "static-1.22846",
  "marketplace-ui-details": "static-1.10527",
  "marketplace-ui-reviews": "static-1.20587",
  "marketplace-ui-tracking": "static-1.14802",
  "sanitize-text": "static-1.8412",
  "usage-tracker-multi": "static-1.6031",
  "usage-tracker-session-replay": "static-1.5303",
  "wootric-nps": "static-1.7173",
  "quartz-head": "static-1.1061",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4916",
  "immer": "static-1.94",
  "immerable": "static-1.4412",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2652",
  "reporting-data": "static-1.68652",
  "cssUtils": "static-1.877",
  "flux-actions": "static-1.362",
  "HubStyle": "static-2.12051",
  "PatternValidationJS": "static-1.3158",
  "react-colorpicker": "static-2.10468",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10629",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7607",
  "icons": "static-2.675",
  "marketplace-ui-apps-core": "static-1.19164",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4771",
  "foundations-components-test-utils": "static-1.5902",
  "quartz-i18n": "static-1.1071",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.380",
  "ads-unified-auth-lib": "static-1.1133",
  "google-sheets-integration-lib": "static-1.957",
  "microsoft-drive-auth-lib": "static-1.53",
  "surveymonkey-integration-lib": "static-1.400",
  "slack-ui-library": "static-1.10659",
  "fsm": "static-1.4002",
  "customer-data-objects": "static-1.7948",
  "property-translator": "static-1.5657",
  "hs-locale-management": "static-1.266",
  "frontend-preferences-client": "static-1.8187",
  "hs-promise-utils": "static-1.5855",
  "hubspot-apollo-client": "static-1.5139",
  "integrations-error-boundary-lib": "static-1.14372",
  "integrations-tracking-lib": "static-1.5868",
  "native-integrations-shared-strings": "static-1.8038",
  "sanitize": "static-1.4736",
  "superstore": "static-1.5016",
  "ui-shepherd-react": "static-3.10526",
  "ai-settings-ui-library": "static-1.8272",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4836",
  "immutable-less": "static-1.4911",
  "marketplace-ui-client-types": "static-1.18039",
  "nav-meta": "static-1.30376",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18333",
  "ui-product-approvals-common": "static-1.917",
  "ai-studio-lib": "static-1.12386",
  "hubspot-prosemirror": "static-1.18897",
  "integrations-reconnect-lib": "static-1.427",
  "ui-addon-iframeable": "static-1.9335",
  "ui-addon-integrations-directory-panel": "static-2.8287",
  "ui-product-approvals": "static-1.29022",
  "ui-tool-access": "static-1.10414",
  "inbound-db-properties-service-client": "static-1.4030",
  "property-management-common": "static-1.6326",
  "opentelemetry-fe-types": "static-1.30",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.571",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.405",
  "quartz-auth": "static-1.1071",
  "quartz-test": "static-1.1071",
  "quartz-tracking": "static-1.775",
  "trellis-components": "static-1.2538",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.333",
  "bender-build-tools": "static-1.3397",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22714",
  "ContentUtils": "static-1.69063",
  "customer-data-objects-ui-components": "static-1.13290",
  "sassPrefix": "static-1.163",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.388",
  "batch-promise": "static-1.1802",
  "event-emitter": "static-1.1214",
  "fast-json-patch": "static-1.67",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5727",
  "magpie-types": "static-1.5187",
  "avatar-components": "static-1.2755",
  "breeze-engine-core": "static-1.886",
  "breeze-onboarding-components": "static-1.645",
  "customer-data-filters-ui": "static-1.40798",
  "customer-data-reference-ui-components": "static-1.13440",
  "embedded-academy-lib": "static-1.15405",
  "ExportDialog": "static-6.10639",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41942",
  "reporting-snowflake": "static-1.57269",
  "reporting-ui-components": "static-2.65922",
  "reporting-visualizations": "static-1.60727",
  "trial-components-library": "static-1.14044",
  "trellis-theming": "static-1.1227",
  "ui-addon-teams": "static-1.21868",
  "upgrade-components-lib": "static-1.470",
  "navigation-components": "static-1.18739",
  "breeze-engine-lib": "static-1.1608",
  "simple-logging-lib": "static-1.3311",
  "fail-safe": "static-1.214",
  "app-governance-lib": "static-1.2321",
  "developer-experience-shared-components": "static-1.10764",
  "purchase-motions-components": "static-1.6299",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10087",
  "usage-tracker-anonymous": "static-1.6034",
  "usage-tracker-public": "static-1.7428",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3959",
  "reference-resolvers": "static-1.8440",
  "ui-extensibility-client-types": "static-1.4181",
  "hubspot-apollo-cache": "static-1.598",
  "universal-page-editor-lib": "static-1.3268",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3462",
  "atom": "static-1.5346",
  "merchandise-lib": "static-1.274",
  "salesImages": "static-1.532",
  "ui-addon-draggable": "static-3.5016",
  "content-assistance-lib": "static-1.8149",
  "content-media-capture": "static-1.5348",
  "customer-data-ui-utilities": "static-1.10088",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24396",
  "growth-payments-core": "static-1.26102",
  "knowledge-content-types": "static-1.8628",
  "payment-link-components": "static-1.24098",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20252",
  "ui-addon-emoji-picker": "static-1.10146",
  "ui-business-units-lib": "static-1.9344",
  "video-components-external": "static-1.12086",
  "video-data-lib": "static-1.35744",
  "navigation-messaging": "static-1.8066",
  "collaboration-sidebar": "static-1.58640",
  "react-dnd-compat": "static-1.4876",
  "crm-component-utils": "static-1.39756",
  "crm-properties-common-lib": "static-1.6150",
  "customer-data-properties": "static-1.52473",
  "external-options-client-types": "static-1.4313",
  "framework-data-schema-resolvers": "static-1.7153",
  "property-value-citations": "static-1.3087",
  "reference-resolvers-lite": "static-1.8361",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10548",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5075",
  "content-icons-ui": "static-1.2324",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.982",
  "breeze-artifacts-sdk": "static-1.225",
  "onboarding-journeys-lib": "static-1.819",
  "conversations-skeleton-state": "static-1.7510",
  "crm-message-bus": "static-1.43670",
  "customer-data-filters-ui-msw-helpers": "static-1.23233",
  "events-data-lib": "static-1.501",
  "FormUrlGenerator": "static-2.4988",
  "framework-builder-read-service-client": "static-1.4195",
  "hs-resources": "static-1.452",
  "multi-account-reference-resolvers": "static-1.1259",
  "onboarding-scopes": "static-1.6715",
  "onboarding-tours": "static-1.17061",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14393",
  "academy-common-lib": "static-1.14865",
  "dashboard-lib": "static-1.82679",
  "getting-started-shared-tasks": "static-1.19146",
  "hubspot-prosemirror-plugins": "static-1.18889",
  "share-with-third-party-component-lib": "static-1.8966",
  "ui-asset-management-lib": "static-1.11356",
  "user-context": "static-1.5378",
  "reporting-plugins": "static-1.10686",
  "reporting-reports": "static-1.68329",
  "hubs-service-types": "static-1.1519",
  "purchase-motions-api": "static-1.6302",
  "signup-constants": "static-1.19538",
  "nest": "static-1.496",
  "breeze-engine-chat-components": "static-1.586",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.165",
  "framework-listing-lib": "static-2.29410",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31361",
  "apps-service-types": "static-1.4001",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8320",
  "onboarding-tours-client": "static-1.5275",
  "one-click-checkout": "static-1.321",
  "platform-infra-nav-components": "static-1.7863",
  "subscription-experience-data-types": "static-1.15213",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10018",
  "redux-thunk": "static-2.77",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29241",
  "content-media-composition-data-lib": "static-1.13152",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4687",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.655",
  "ui-addon-opt": "static-4.8627",
  "commerce-tours-lib": "static-1.6555",
  "growth-onboarding-reliability": "static-1.5341",
  "sales-checkout-service-client": "static-1.3789",
  "data-token-picker": "static-1.16834",
  "FileManagerLib": "static-1.40036",
  "content-media-compositions": "static-2.17159",
  "media-bridge-lib": "static-1.19353",
  "chatspot-widget-iframe": "static-1.22705",
  "collaboration-sidebar-common": "static-1.3437",
  "marketing-platform-lib": "static-1.7128",
  "card-properties-lib": "static-1.44931",
  "commerce-subscription-lib": "static-1.37705",
  "crm-actions": "static-1.6611",
  "crm-cards-sdk": "static-1.44429",
  "customer-data-properties-shared-msw-handlers": "static-1.9877",
  "customer-data-tracking": "static-1.7142",
  "calling-global-api": "static-1.65432",
  "calling-internal-common": "static-1.31579",
  "calling-lifecycle-internal": "static-1.66814",
  "calling-lifecycle-messages": "static-1.59108",
  "commerce-products-lib": "static-1.10443",
  "conditional-properties-service-client": "static-1.3986",
  "crm-index-visualization-core": "static-1.4491",
  "crm-links": "static-1.6587",
  "crm-pipelines-api-client-types": "static-1.4321",
  "formula-editor": "static-1.14693",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4398",
  "meetings-icalendar-utils-lib": "static-1.896",
  "multi-currency-client-types": "static-1.3882",
  "object-builder-ui-client": "static-1.49577",
  "pipeline-validation-client-types": "static-1.4155",
  "smart-data-capture-core": "static-1.55",
  "smart-property-lib": "static-1.8204",
  "tiered-pricing": "static-1.1893",
  "topics-actions-lib": "static-1.425",
  "ui-addon-form-validation": "static-1.11246",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.272",
  "framework-data-schema-quick-fetch": "static-1.7058",
  "restore-request-side-panel-lib": "static-1.1589",
  "growth-data-modal": "static-1.5838",
  "growth-onboarding-confetti": "static-1.3323",
  "growth-onboarding-next-action-utils": "static-1.2622",
  "onboarding-tours-utils": "static-1.1127",
  "ui-shepherd-tracker": "static-1.7907",
  "academy-service-client": "static-1.3949",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39895",
  "SafeStorage": "static-1.4665",
  "video-embed": "static-1.36578",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24937",
  "viral-links-lib": "static-1.7334",
  "nested-table": "static-1.496",
  "timezone-utils": "static-2.5507",
  "getting-started-shared-tasks-store": "static-1.18264",
  "campaign-roi-lib": "static-1.10030",
  "ui-addon-calendars": "static-2.5589",
  "customer-data-views-management": "static-1.25957",
  "framework-data-table": "static-2.12480",
  "nudge-client-utils": "static-1.3089",
  "nudge-custom-ui-functions": "static-1.1437",
  "switchboard-lib": "static-1.476",
  "access-check-ui-lib": "static-1.1510",
  "app-users-service-client": "static-1.5880",
  "app-users-service-types": "static-1.5288",
  "mini-checkout-client": "static-1.27416",
  "onboarding-utils": "static-1.5625",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29226",
  "checkout-sdk": "static-3.24259",
  "payment-method-components": "static-1.7107",
  "touchless-buying-components": "static-1.6127",
  "upgrade-catalog-service-types": "static-1.3745",
  "edison-service-client-types": "static-1.653",
  "growth-onboarding-feedback-components": "static-1.6845",
  "audio-components": "static-1.6289",
  "FileManagerImages": "static-1.37547",
  "video-components": "static-1.14088",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92751",
  "customer-data-sidebar": "static-2.46668",
  "enrichment-lib": "static-1.193",
  "ui-addon-draggable-compat": "static-2.4524",
  "universal-record-utils-lib": "static-1.1779",
  "commerce-billing-lib": "static-1.20038",
  "commerce-shared-components-lib": "static-1.19152",
  "commerce-tools-ui-lib": "static-1.10979",
  "crm-fe-perf": "static-1.23161",
  "calling-error-reporting": "static-1.31586",
  "shared-worker-versioning": "static-1.11300",
  "calling-usage-tracker": "static-1.6799",
  "voice-sms-access-library": "static-1.1942",
  "commerce-permissions": "static-1.1037",
  "products-iframe-lib": "static-1.8520",
  "products-ui-components-shared-msw-handlers": "static-1.10932",
  "crm-index-associations-lib": "static-1.6703",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10633",
  "sales-views-client-types": "static-1.4517",
  "bark-lib": "static-1.16767",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.591",
  "policy-lib": "static-1.7057",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10696",
  "onboarding-data-sync-lib": "static-1.2437",
  "growth-onboarding-next-action-components": "static-1.2650",
  "user-context-client": "static-1.4769",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4793",
  "outpost": "static-1.4420",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22103",
  "sales-email-signature-service-client": "static-1.4106",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6544",
  "crm-view-components": "static-1.1025",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7588",
  "tasks-actions-lib": "static-1.47",
  "nudge-custom-function-registry": "static-1.2846",
  "nudge-renderer-utils": "static-1.3165",
  "whisper-core-api": "static-1.7256",
  "InboxConnectUtils": "static-4.15483",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46772",
  "hub-http-rxjs": "static-1.835",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4252",
  "company-details-components": "static-1.6461",
  "react-performance-metrics-lib": "static-1.817",
  "pricing-pages-ui-components": "static-1.15576",
  "quote-checkout-service-types": "static-1.3719",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22444",
  "customer-data-email": "static-1.18471",
  "card-payment-highlight-lib": "static-1.37898",
  "card-subscription-highlight-lib": "static-1.40128",
  "commerce-contract-lib": "static-1.13203",
  "invoices-highlight-card-lib": "static-1.55586",
  "orders-highlight-card-lib": "static-1.22117",
  "products-highlight-card-lib": "static-1.18726",
  "quotes-highlight-card-lib": "static-1.72762",
  "crm-source-interpretation-lib": "static-1.5593",
  "data-agent-utils": "static-1.255",
  "crm-object-search-query-utilities": "static-1.10136",
  "utility-belt": "static-1.2792",
  "payments-enrollment-embed-lib": "static-1.23729",
  "stripe-embedded-components": "static-1.7943",
  "customer-data-rte": "static-1.33582",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6212",
  "payments-post-enroll-local-storage-lib": "static-1.5367",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38852",
  "calling-orchestration-schema": "static-1.36719",
  "react-reducer-toolkit": "static-1.16292",
  "meetings-connect-utils-lib": "static-1.7870",
  "hub-http-contrib": "static-1.3298",
  "ui-addon-sales-email": "static-1.5476",
  "access-control-lib": "static-1.10697",
  "EmailComponents": "static-1.55478",
  "EmailData": "static-1.54156",
  "redux-less": "static-2.9739",
  "company-details-service-types": "static-1.4200",
  "segments-query-core": "static-1.1684",
  "pricing-pages-api": "static-1.15441",
  "sequences-lib": "static-1.8483",
  "ui-gdpr-components": "static-1.10617",
  "products-ui-components": "static-1.40961",
  "accounting-integrations-ui-components": "static-1.7486",
  "invoices-ui-lib": "static-1.55602",
  "commerce-products-api": "static-1.2649",
  "invoices-iframe-lib": "static-1.57660",
  "quotes-modal-lib": "static-1.103440",
  "quotes-ui-lib": "static-1.81483",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28845",
  "ContentComponents": "static-2.72019",
  "ContentData": "static-1.69138",
  "marketing-contacts-lib": "static-1.10936",
  "marketing-email-service-types": "static-1.2073",
  "messaging-editing-lib": "static-1.47058",
  "messaging-usage-based-billing-components-lib": "static-1.1920",
  "automation-ui-source-apps": "static-1.19593",
  "automation-ui-types": "static-1.20511",
  "messaging-types-lib": "static-1.46795",
  "onboarding-settings-client": "static-1.4769",
  "sequences-client-types-lib": "static-1.8340",
  "commerce-tax-lib": "static-1.799",
  "price-books-api": "static-1.1660",
  "price-books-components": "static-1.1718",
  "property-description-translator": "static-1.4100",
  "ramp-editor": "static-1.827",
  "commerce-analytics-service-client": "static-1.3777",
  "totals-ui-components": "static-1.24227",
  "SalesContentIndexUI": "static-3.9581",
  "advanced-menus-core": "static-1.15525",
  "advanced-menus-lib": "static-1.12404",
  "automation-ui-ubb": "static-1.6427",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7598",
  "data-token-views": "static-1.16815",
  "forms-utils-lib": "static-1.13039",
  "payments-embed-points-lib": "static-1.13531",
  "react-tinymce": "static-1.55904",
  "simple-menus-core": "static-1.15524",
  "simple-menus-lib": "static-1.17041",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55030",
  "tinymce-data": "static-1.41115",
  "tinymce-plugins": "static-1.58144",
  "tinymce-themes": "static-1.57000",
  "ui-brand-identity-lib": "static-1.16285",
  "ui-memberships-settings-lib": "static-1.34768",
  "videoconference-integration-components": "static-1.7193",
  "marketing-contacts-client": "static-1.7770",
  "mc-hard-limits-client-types": "static-1.164",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77830",
  "short-messages-app-service-client": "static-1.4177",
  "web-interactives-components": "static-1.14194",
  "web-interactives-data": "static-1.14195",
  "messaging-shared-utils-lib": "static-1.1369",
  "messaging-user-info-utils-lib": "static-1.1539",
  "email-portal-health-service-types": "static-1.1239",
  "line-items-api": "static-1.1048",
  "commerce-totals-service-types": "static-1.4004",
  "FireAlarmUi": "static-1.4692",
  "sales-templates-service-types-lib": "static-1.4357",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22447",
  "automation-ui-usage-tracking": "static-1.21910",
  "data-studio-ubb": "static-1.3437",
  "interframe": "static-3.5016",
  "layout-dnd-components": "static-1.12908",
  "layout-dnd-utils": "static-1.11883",
  "NamespacedHubStyle": "static-2.9235",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27589",
  "content-management-data-lib": "static-1.5897",
  "copilot-plugins": "static-1.11746",
  "cta-picker": "static-1.37019",
  "customer-agent-discovery-components-lib": "static-1.3808",
  "editor-components": "static-1.13597",
  "editor-iframe-lib": "static-1.8748",
  "error-messaging-js": "static-1.5457",
  "FormsCommonComponents": "static-1.86491",
  "layout-data-lib": "static-1.10208",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10910",
  "SharedLegalStrings": "static-1.2008",
  "smart-content-core": "static-1.43103",
  "smart-content-lib": "static-1.43756",
  "social-composer-lib": "static-1.60138",
  "structured-content-lib": "static-1.25851",
  "theme-previewer-lib": "static-1.53877",
  "tinymce-copilot": "static-1.17098",
  "xray-recommendation-lib": "static-1.8219",
  "automation-ui-routing": "static-1.21868",
  "sql-reporting-client-types": "static-1.5859",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42721",
  "campaigns-utils-lib": "static-1.3463",
  "reporting-enablement": "static-1.23748",
  "forms-ai-lib": "static-1.4710",
  "codemirror-dlb": "static-1.59389",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6699",
  "report-customization-components": "static-1.13834",
  "data-quality-ui-library": "static-1.13715",
  "reporting-filters": "static-1.937",
  "reporting-insights-lib": "static-1.2493"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13153",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.651",
  "client-types": "/client-types/static-1.494",
  "data-fetching-client": "/data-fetching-client/static-1.9918",
  "foundations-components": "/foundations-components/static-1.8419",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1444",
  "foundations-theming": "/foundations-theming/static-1.4728",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8289",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10550",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11744",
  "I18n": "/I18n/static-7.1665",
  "jasmine-runner": "/jasmine-runner/static-1.6713",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.573",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13216",
  "quartz": "/quartz/static-1.7396",
  "react-dlb": "/react-dlb/static-1.87",
  "react-rhumb": "/react-rhumb/static-1.16972",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3116",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10585",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12781",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7579",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11404",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9797",
  "unified-auth": "/unified-auth/static-1.834",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1116",
  "usage-tracker": "/usage-tracker/static-1.7617",
  "usage-tracker-core": "/usage-tracker-core/static-1.7467",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8359",
  "hub-http": "/hub-http/static-1.6473",
  "integrations-lib": "/integrations-lib/static-1.16957",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20632",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.618",
  "property-management-iframe": "/property-management-iframe/static-1.14038",
  "quartz-config": "/quartz-config/static-1.1174",
  "quartz-core": "/quartz-core/static-1.6615",
  "quartz-routing": "/quartz-routing/static-1.826",
  "quick-fetch": "/quick-fetch/static-1.4104",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4923",
  "ts-schema": "/ts-schema/static-1.4267",
  "ui-universal-auth": "/ui-universal-auth/static-1.9320",
  "UIComponents": "/UIComponents/static-3.8690",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3673",
  "quartz-webpack": "/quartz-webpack/static-1.3620",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.474",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9628",
  "codemirror": "/codemirror/static-5.99",
  "foundations-assets": "/foundations-assets/static-1.5144",
  "pulse": "/pulse/static-1.885",
  "react-codemirror": "/react-codemirror/static-1.10899",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.519",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4688",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2444",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9687",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5528",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2519",
  "ui-fonts": "/ui-fonts/static-1.1006",
  "ui-images": "/ui-images/static-2.1233",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3211",
  "foundations-theming-base": "/foundations-theming-base/static-1.3713",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.791",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3400",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4577",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8964",
  "ai-rendering-library": "/ai-rendering-library/static-1.11029",
  "chirp-fetch": "/chirp-fetch/static-1.2154",
  "connections-embed-lib": "/connections-embed-lib/static-1.1454",
  "copilot-toolkit": "/copilot-toolkit/static-1.11774",
  "feedback-loader": "/feedback-loader/static-1.29754",
  "laboratory-lib": "/laboratory-lib/static-3.7413",
  "marketplace-embed": "/marketplace-embed/static-1.22846",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10527",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20587",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14802",
  "sanitize-text": "/sanitize-text/static-1.8412",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6031",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5303",
  "wootric-nps": "/wootric-nps/static-1.7173",
  "quartz-head": "/quartz-head/static-1.1061",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4916",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4412",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "reporting-data": "/reporting-data/static-1.68652",
  "cssUtils": "/cssUtils/static-1.877",
  "flux-actions": "/flux-actions/static-1.362",
  "HubStyle": "/HubStyle/static-2.12051",
  "PatternValidationJS": "/PatternValidationJS/static-1.3158",
  "react-colorpicker": "/react-colorpicker/static-2.10468",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10629",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7607",
  "icons": "/icons/static-2.675",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19164",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4771",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5902",
  "quartz-i18n": "/quartz-i18n/static-1.1071",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.380",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1133",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.957",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.53",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.400",
  "slack-ui-library": "/slack-ui-library/static-1.10659",
  "fsm": "/fsm/static-1.4002",
  "customer-data-objects": "/customer-data-objects/static-1.7948",
  "property-translator": "/property-translator/static-1.5657",
  "hs-locale-management": "/hs-locale-management/static-1.266",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8187",
  "hs-promise-utils": "/hs-promise-utils/static-1.5855",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5139",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14372",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5868",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8038",
  "sanitize": "/sanitize/static-1.4736",
  "superstore": "/superstore/static-1.5016",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10526",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8272",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4836",
  "immutable-less": "/immutable-less/static-1.4911",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18039",
  "nav-meta": "/nav-meta/static-1.30376",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18333",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.917",
  "ai-studio-lib": "/ai-studio-lib/static-1.12386",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18897",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.427",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9335",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8287",
  "ui-product-approvals": "/ui-product-approvals/static-1.29022",
  "ui-tool-access": "/ui-tool-access/static-1.10414",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4030",
  "property-management-common": "/property-management-common/static-1.6326",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.30",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.571",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.405",
  "quartz-auth": "/quartz-auth/static-1.1071",
  "quartz-test": "/quartz-test/static-1.1071",
  "quartz-tracking": "/quartz-tracking/static-1.775",
  "trellis-components": "/trellis-components/static-1.2538",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.333",
  "bender-build-tools": "/bender-build-tools/static-1.3397",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22714",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13290",
  "sassPrefix": "/sassPrefix/static-1.163",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.388",
  "batch-promise": "/batch-promise/static-1.1802",
  "event-emitter": "/event-emitter/static-1.1214",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5727",
  "magpie-types": "/magpie-types/static-1.5187",
  "avatar-components": "/avatar-components/static-1.2755",
  "breeze-engine-core": "/breeze-engine-core/static-1.886",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.645",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40798",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13440",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15405",
  "ExportDialog": "/ExportDialog/static-6.10639",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41942",
  "reporting-snowflake": "/reporting-snowflake/static-1.57269",
  "reporting-ui-components": "/reporting-ui-components/static-2.65922",
  "reporting-visualizations": "/reporting-visualizations/static-1.60727",
  "trial-components-library": "/trial-components-library/static-1.14044",
  "trellis-theming": "/trellis-theming/static-1.1227",
  "ui-addon-teams": "/ui-addon-teams/static-1.21868",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.470",
  "navigation-components": "/navigation-components/static-1.18739",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1608",
  "simple-logging-lib": "/simple-logging-lib/static-1.3311",
  "fail-safe": "/fail-safe/static-1.214",
  "app-governance-lib": "/app-governance-lib/static-1.2321",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10764",
  "purchase-motions-components": "/purchase-motions-components/static-1.6299",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10087",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6034",
  "usage-tracker-public": "/usage-tracker-public/static-1.7428",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3959",
  "reference-resolvers": "/reference-resolvers/static-1.8440",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4181",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.598",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3268",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3462",
  "atom": "/atom/static-1.5346",
  "merchandise-lib": "/merchandise-lib/static-1.274",
  "salesImages": "/salesImages/static-1.532",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5016",
  "content-assistance-lib": "/content-assistance-lib/static-1.8149",
  "content-media-capture": "/content-media-capture/static-1.5348",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10088",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24396",
  "growth-payments-core": "/growth-payments-core/static-1.26102",
  "knowledge-content-types": "/knowledge-content-types/static-1.8628",
  "payment-link-components": "/payment-link-components/static-1.24098",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20252",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10146",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9344",
  "video-components-external": "/video-components-external/static-1.12086",
  "video-data-lib": "/video-data-lib/static-1.35744",
  "navigation-messaging": "/navigation-messaging/static-1.8066",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58640",
  "react-dnd-compat": "/react-dnd-compat/static-1.4876",
  "crm-component-utils": "/crm-component-utils/static-1.39756",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6150",
  "customer-data-properties": "/customer-data-properties/static-1.52473",
  "external-options-client-types": "/external-options-client-types/static-1.4313",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7153",
  "property-value-citations": "/property-value-citations/static-1.3087",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8361",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10548",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5075",
  "content-icons-ui": "/content-icons-ui/static-1.2324",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.982",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.225",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.819",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7510",
  "crm-message-bus": "/crm-message-bus/static-1.43670",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23233",
  "events-data-lib": "/events-data-lib/static-1.501",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4988",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4195",
  "hs-resources": "/hs-resources/static-1.452",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1259",
  "onboarding-scopes": "/onboarding-scopes/static-1.6715",
  "onboarding-tours": "/onboarding-tours/static-1.17061",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14393",
  "academy-common-lib": "/academy-common-lib/static-1.14865",
  "dashboard-lib": "/dashboard-lib/static-1.82679",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19146",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18889",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8966",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11356",
  "user-context": "/user-context/static-1.5378",
  "reporting-plugins": "/reporting-plugins/static-1.10686",
  "reporting-reports": "/reporting-reports/static-1.68329",
  "hubs-service-types": "/hubs-service-types/static-1.1519",
  "purchase-motions-api": "/purchase-motions-api/static-1.6302",
  "signup-constants": "/signup-constants/static-1.19538",
  "nest": "/nest/static-1.496",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.586",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.165",
  "framework-listing-lib": "/framework-listing-lib/static-2.29410",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31361",
  "apps-service-types": "/apps-service-types/static-1.4001",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8320",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5275",
  "one-click-checkout": "/one-click-checkout/static-1.321",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7863",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15213",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10018",
  "redux-thunk": "/redux-thunk/static-2.77",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29241",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13152",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4687",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.655",
  "ui-addon-opt": "/ui-addon-opt/static-4.8627",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6555",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5341",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3789",
  "data-token-picker": "/data-token-picker/static-1.16834",
  "FileManagerLib": "/FileManagerLib/static-1.40036",
  "content-media-compositions": "/content-media-compositions/static-2.17159",
  "media-bridge-lib": "/media-bridge-lib/static-1.19353",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22705",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3437",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7128",
  "card-properties-lib": "/card-properties-lib/static-1.44931",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37705",
  "crm-actions": "/crm-actions/static-1.6611",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44429",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9877",
  "customer-data-tracking": "/customer-data-tracking/static-1.7142",
  "calling-global-api": "/calling-global-api/static-1.65432",
  "calling-internal-common": "/calling-internal-common/static-1.31579",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66814",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59108",
  "commerce-products-lib": "/commerce-products-lib/static-1.10443",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3986",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4491",
  "crm-links": "/crm-links/static-1.6587",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4321",
  "formula-editor": "/formula-editor/static-1.14693",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4398",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.896",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3882",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49577",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4155",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.55",
  "smart-property-lib": "/smart-property-lib/static-1.8204",
  "tiered-pricing": "/tiered-pricing/static-1.1893",
  "topics-actions-lib": "/topics-actions-lib/static-1.425",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11246",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.272",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7058",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1589",
  "growth-data-modal": "/growth-data-modal/static-1.5838",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3323",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2622",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1127",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7907",
  "academy-service-client": "/academy-service-client/static-1.3949",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39895",
  "SafeStorage": "/SafeStorage/static-1.4665",
  "video-embed": "/video-embed/static-1.36578",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24937",
  "viral-links-lib": "/viral-links-lib/static-1.7334",
  "nested-table": "/nested-table/static-1.496",
  "timezone-utils": "/timezone-utils/static-2.5507",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18264",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10030",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5589",
  "customer-data-views-management": "/customer-data-views-management/static-1.25957",
  "framework-data-table": "/framework-data-table/static-2.12480",
  "nudge-client-utils": "/nudge-client-utils/static-1.3089",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1437",
  "switchboard-lib": "/switchboard-lib/static-1.476",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1510",
  "app-users-service-client": "/app-users-service-client/static-1.5880",
  "app-users-service-types": "/app-users-service-types/static-1.5288",
  "mini-checkout-client": "/mini-checkout-client/static-1.27416",
  "onboarding-utils": "/onboarding-utils/static-1.5625",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29226",
  "checkout-sdk": "/checkout-sdk/static-3.24259",
  "payment-method-components": "/payment-method-components/static-1.7107",
  "touchless-buying-components": "/touchless-buying-components/static-1.6127",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3745",
  "edison-service-client-types": "/edison-service-client-types/static-1.653",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6845",
  "audio-components": "/audio-components/static-1.6289",
  "FileManagerImages": "/FileManagerImages/static-1.37547",
  "video-components": "/video-components/static-1.14088",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92751",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46668",
  "enrichment-lib": "/enrichment-lib/static-1.193",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4524",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1779",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20038",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19152",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10979",
  "crm-fe-perf": "/crm-fe-perf/static-1.23161",
  "calling-error-reporting": "/calling-error-reporting/static-1.31586",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11300",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6799",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1942",
  "commerce-permissions": "/commerce-permissions/static-1.1037",
  "products-iframe-lib": "/products-iframe-lib/static-1.8520",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10932",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6703",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10633",
  "sales-views-client-types": "/sales-views-client-types/static-1.4517",
  "bark-lib": "/bark-lib/static-1.16767",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.591",
  "policy-lib": "/policy-lib/static-1.7057",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10696",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2437",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2650",
  "user-context-client": "/user-context-client/static-1.4769",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4793",
  "outpost": "/outpost/static-1.4420",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22103",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4106",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6544",
  "crm-view-components": "/crm-view-components/static-1.1025",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7588",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.47",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2846",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3165",
  "whisper-core-api": "/whisper-core-api/static-1.7256",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15483",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46772",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.835",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4252",
  "company-details-components": "/company-details-components/static-1.6461",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.817",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15576",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3719",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22444",
  "customer-data-email": "/customer-data-email/static-1.18471",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37898",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40128",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13203",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55586",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22117",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18726",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72762",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5593",
  "data-agent-utils": "/data-agent-utils/static-1.255",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10136",
  "utility-belt": "/utility-belt/static-1.2792",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23729",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7943",
  "customer-data-rte": "/customer-data-rte/static-1.33582",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6212",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5367",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38852",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36719",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16292",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7870",
  "hub-http-contrib": "/hub-http-contrib/static-1.3298",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5476",
  "access-control-lib": "/access-control-lib/static-1.10697",
  "EmailComponents": "/EmailComponents/static-1.55478",
  "EmailData": "/EmailData/static-1.54156",
  "redux-less": "/redux-less/static-2.9739",
  "company-details-service-types": "/company-details-service-types/static-1.4200",
  "segments-query-core": "/segments-query-core/static-1.1684",
  "pricing-pages-api": "/pricing-pages-api/static-1.15441",
  "sequences-lib": "/sequences-lib/static-1.8483",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10617",
  "products-ui-components": "/products-ui-components/static-1.40961",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7486",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55602",
  "commerce-products-api": "/commerce-products-api/static-1.2649",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57660",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103440",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81483",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28845",
  "ContentComponents": "/ContentComponents/static-2.72019",
  "ContentData": "/ContentData/static-1.69138",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10936",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2073",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47058",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1920",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19593",
  "automation-ui-types": "/automation-ui-types/static-1.20511",
  "messaging-types-lib": "/messaging-types-lib/static-1.46795",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4769",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8340",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.799",
  "price-books-api": "/price-books-api/static-1.1660",
  "price-books-components": "/price-books-components/static-1.1718",
  "property-description-translator": "/property-description-translator/static-1.4100",
  "ramp-editor": "/ramp-editor/static-1.827",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3777",
  "totals-ui-components": "/totals-ui-components/static-1.24227",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9581",
  "advanced-menus-core": "/advanced-menus-core/static-1.15525",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12404",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6427",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7598",
  "data-token-views": "/data-token-views/static-1.16815",
  "forms-utils-lib": "/forms-utils-lib/static-1.13039",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13531",
  "react-tinymce": "/react-tinymce/static-1.55904",
  "simple-menus-core": "/simple-menus-core/static-1.15524",
  "simple-menus-lib": "/simple-menus-lib/static-1.17041",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55030",
  "tinymce-data": "/tinymce-data/static-1.41115",
  "tinymce-plugins": "/tinymce-plugins/static-1.58144",
  "tinymce-themes": "/tinymce-themes/static-1.57000",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16285",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34768",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7193",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7770",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.164",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77830",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4177",
  "web-interactives-components": "/web-interactives-components/static-1.14194",
  "web-interactives-data": "/web-interactives-data/static-1.14195",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1369",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1539",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1239",
  "line-items-api": "/line-items-api/static-1.1048",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4004",
  "FireAlarmUi": "/FireAlarmUi/static-1.4692",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4357",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22447",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21910",
  "data-studio-ubb": "/data-studio-ubb/static-1.3437",
  "interframe": "/interframe/static-3.5016",
  "layout-dnd-components": "/layout-dnd-components/static-1.12908",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11883",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9235",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27589",
  "content-management-data-lib": "/content-management-data-lib/static-1.5897",
  "copilot-plugins": "/copilot-plugins/static-1.11746",
  "cta-picker": "/cta-picker/static-1.37019",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3808",
  "editor-components": "/editor-components/static-1.13597",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8748",
  "error-messaging-js": "/error-messaging-js/static-1.5457",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86491",
  "layout-data-lib": "/layout-data-lib/static-1.10208",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10910",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2008",
  "smart-content-core": "/smart-content-core/static-1.43103",
  "smart-content-lib": "/smart-content-lib/static-1.43756",
  "social-composer-lib": "/social-composer-lib/static-1.60138",
  "structured-content-lib": "/structured-content-lib/static-1.25851",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53877",
  "tinymce-copilot": "/tinymce-copilot/static-1.17098",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8219",
  "automation-ui-routing": "/automation-ui-routing/static-1.21868",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5859",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42721",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3463",
  "reporting-enablement": "/reporting-enablement/static-1.23748",
  "forms-ai-lib": "/forms-ai-lib/static-1.4710",
  "codemirror-dlb": "/codemirror-dlb/static-1.59389",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6699",
  "report-customization-components": "/report-customization-components/static-1.13834",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13715",
  "reporting-filters": "/reporting-filters/static-1.937",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2493"
}
};
